@switch (field.controlType) {
  @case ('integer') {
    <mat-form-field class="me-2">
      <mat-label>{{ field.label }}</mat-label>
      <input
        matInput
        [formControl]="filterForm.controls[groupKey].controls[field.varName]"
        (change)="changeText($event)"
      />
      @if (field.conditionalHint) {
        <mat-hint>{{ field.conditionalHint }}</mat-hint>
      }
    </mat-form-field>
  }
  @case ('currency') {
    <mat-form-field class="me-2">
      <mat-label>{{ field.label }}</mat-label>
      <input
        matInput
        maxlength="20"
        [maskito]="dollarMask"
        [formControl]="filterForm.controls[groupKey].controls[field.varName]"
        (change)="changeText($event)"
      />
      @if (field.conditionalHint) {
        <mat-hint>{{ field.conditionalHint }}</mat-hint>
      }
    </mat-form-field>
  }
  @case ('text') {
    <mat-form-field class="me-2">
      <mat-label>{{ field.label }}</mat-label>
      <input
        matInput
        [formControl]="filterForm.controls[groupKey].controls[field.varName]"
        (change)="changeText($event)"
      />
      @if (
        filterForm.controls[groupKey].controls[field.varName].value &&
        filterForm.controls[groupKey].controls[field.varName].value.length >= 1
      ) {
        <button
          matSuffix
          matIconButton
          aria-label="Clear"
          color="warn"
          type="button"
          matTooltip="Clear Filter"
          (click)="clearFilter.emit($event, field, groupKey)"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
      @if (field.conditionalHint) {
        <mat-hint>{{ field.conditionalHint }}</mat-hint>
      }
    </mat-form-field>
  }
  @case ('states') {
    <mat-form-field class="me-2">
      <mat-label>Select States to Filter by</mat-label>
      <mat-select
        multiple
        [formControl]="filterForm.controls[groupKey].controls[field.varName]"
        (selectionChange)="changeSelection($event)"
      >
        @for (state of states; track state.value) {
          <mat-option [value]="state.value">
            {{ state.label }}
          </mat-option>
        }
      </mat-select>
      @if (field.conditionalHint) {
        <mat-hint>{{ field.conditionalHint }}</mat-hint>
      }
    </mat-form-field>
  }
  @case ('simpleDropdown') {
    <mat-form-field
      class="me-2"
      [ngClass]="{ 'policy-review': field.varName === 'Carrier' }"
    >
      <mat-label>{{ field.label }}</mat-label>
      <mat-select
        [formControl]="filterForm.controls[groupKey].controls[field.varName]"
        (selectionChange)="changeSelection($event)"
      >
        @for (opt of field.options; track opt.value) {
          <mat-option
            value="{{ opt.value }}"
            [ngClass]="{ 'policy-review-select': field.varName === 'Carrier' }"
          >
            {{ opt.display }}
          </mat-option>
        }
      </mat-select>
      @if (
        filterForm.value[groupKey][field.varName] &&
        filterForm.value[groupKey][field.varName].length >= 1
      ) {
        <button
          matSuffix
          matIconButton
          aria-label="Clear"
          color="warn"
          type="button"
          matTooltip="Clear Filter"
          (click)="resetFilter($event)"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
      @if (field.conditionalHint) {
        <mat-hint>{{ field.conditionalHint }}</mat-hint>
      }
    </mat-form-field>
  }
  @case ('dropdown') {
    <mat-form-field class="me-2 typeahead-select">
      <mat-label>{{ field.label }}</mat-label>
      <input
        type="text"
        matInput
        [placeholder]="field.label"
        [matAutocomplete]="typeahead"
        [formControl]="typeaheadControl"
      />
      <mat-autocomplete
        #typeahead="matAutocomplete"
        [displayWith]="displayFn.bind(this)"
        (optionSelected)="changeSelection($event)"
      >
        @for (opt of filteredOptions | async; track opt) {
          <mat-option [value]="opt.value">
            @if (
              field.varName === 'SourceScore' ||
              field.varName === 'DestinationScore' ||
              field.varName === 'LowestScore'
            ) {
              @if (opt.value === 'positive') {
                <span class="icon-label-drop">
                  <mat-icon class="positive">check_circle</mat-icon> Positive
                </span>
              } @else if (opt.value === 'neutral') {
                <span class="icon-label-drop">
                  <mat-icon class="neutral">error</mat-icon> Neutral
                </span>
              } @else if (opt.value === 'negative') {
                <span class="icon-label-drop">
                  <mat-icon class="negative">remove_circle</mat-icon> Negative
                </span>
              } @else {
                {{ opt.display || opt.value }}
              }
            } @else {
              {{ opt.display || opt.value }}
            }
          </mat-option>
        }
      </mat-autocomplete>
      @if (typeaheadControl.value) {
        <button
          matSuffix
          matIconButton
          aria-label="Clear"
          color="warn"
          type="button"
          matTooltip="Clear Filter"
          (click)="resetFilter($event)"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
      @if (field.conditionalHint) {
        <mat-hint>{{ field.conditionalHint }}</mat-hint>
      }
    </mat-form-field>
  }
  @case ('multiselect') {
    <app-multiselect-filter
      [field]="field"
      [filterForm]="filterForm"
      [groupKey]="groupKey"
      (selectionChange)="changeSelection($event)"
      (clearFilter)="clearFilter.emit($event)"
    />
  }
  @case ('chip') {
    <app-chip-filter
      [field]="field"
      [filterForm]="filterForm"
      [groupKey]="groupKey"
      (selectionChange)="changeSelection($event)"
      (clearFilter)="clearFilter.emit($event)"
    />
  }
  @case ('solutionselect') {
    <mat-form-field class="me-2">
      <mat-label>{{ field.label }}</mat-label>
      <mat-select
        [formControl]="filterForm.controls[groupKey].controls[field.varName]"
        (selectionChange)="changeSelection($event)"
      >
        @for (solution of solutions; track solution.value) {
          <mat-option value="{{ solution.value }}">
            {{ solution.label }}
          </mat-option>
        }
      </mat-select>
      @if (
        filterForm.value[groupKey][field.varName] &&
        filterForm.value[groupKey][field.varName].length >= 1 &&
        gridName !== 'CaseExplorer'
      ) {
        <button
          matSuffix
          matIconButton
          aria-label="Clear"
          color="warn"
          type="button"
          matTooltip="Clear Filter"
          (click)="resetFilter($event)"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
      @if (field.conditionalHint) {
        <mat-hint>{{ field.conditionalHint }}</mat-hint>
      }
    </mat-form-field>
  }
  @case ('repreportselect') {
    <mat-form-field class="me-2">
      <mat-label>
        {{ field.label }}
      </mat-label>
      <mat-select
        [formControl]="filterForm.controls[groupKey].controls[field.varName]"
        (selectionChange)="changeSelection($event)"
      >
        @if (reportsLoading) {
          <mat-option disabled value="''" class="dropdownLoadingSpinner">
            <mat-spinner diameter="25" />
          </mat-option>
        } @else {
          @for (report of reportTypes; track $index) {
            @if (report.module.toLowerCase() === reportSolution) {
              <mat-option value="{{ report.value }}">
                {{ report.label }}
              </mat-option>
            }
          }
        }
      </mat-select>
      @if (
        filterForm.value[groupKey][field.varName] &&
        filterForm.value[groupKey][field.varName].length >= 1
      ) {
        <button
          matSuffix
          matIconButton
          aria-label="Clear"
          color="warn"
          type="button"
          matTooltip="Clear Filter"
          (click)="resetFilter($event)"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
      @if (field.conditionalHint) {
        <mat-hint>{{ field.conditionalHint }}</mat-hint>
      }
    </mat-form-field>
  }
  @case ('repCodeMulti') {
    <app-chip-filter
      [field]="field"
      [filterForm]="filterForm"
      [groupKey]="groupKey"
      (selectionChange)="selectionChange.emit($event)"
      (clearFilter)="clearFilter.emit($event)"
    />
  }
  @case ('repCode') {
    <app-rep-code-filter
      [field]="field"
      [filterForm]="filterForm"
      [groupKey]="groupKey"
      [gridName]="gridName"
      (selectionChange)="selectionChange.emit($event)"
      (clearFilter)="clearFilter.emit($event)"
    />
  }
  @case ('unitMulti') {
    <app-chip-filter
      [field]="field"
      [filterForm]="filterForm"
      [groupKey]="groupKey"
      (selectionChange)="selectionChange.emit($event)"
      (clearFilter)="clearFilter.emit($event)"
    />
  }
  @case ('unit') {
    <app-unit-filter
      [field]="field"
      [filterForm]="filterForm"
      [groupKey]="groupKey"
      [gridName]="gridName"
      (selectionChange)="selectionChange.emit($event)"
      (clearFilter)="clearFilter.emit($event)"
    />
  }
  @case ('user') {
    <app-user-filter
      [field]="field"
      [filterForm]="filterForm"
      [groupKey]="groupKey"
      [gridName]="gridName"
      (selectionChange)="selectionChange.emit($event)"
      (clearFilter)="clearFilter.emit($event)"
    />
  }
  @case ('npn') {
    <app-npn-filter
      [field]="field"
      [filterForm]="filterForm"
      [groupKey]="groupKey"
      (selectionChange)="selectionChange.emit($event)"
      (clearFilter)="clearFilter.emit($event)"
    />
  }
  @case ('hashedInput') {
    <mat-form-field class="me-2 rep-code-select">
      <mat-label>{{ field.label }}</mat-label>
      <input
        type="text"
        matInput
        [placeholder]="field.label"
        [formControl]="hashedControl"
        (blur)="hashInput($event)"
        (change)="setHashEvent($event)"
      />
      @if (field.conditionalHint) {
        <mat-hint>{{ field.conditionalHint }}</mat-hint>
      }
    </mat-form-field>
  }
  @case ('range') {
    <mat-form-field class="me-2">
      <mat-label>{{ field.label }}</mat-label>
      <mat-date-range-input [rangePicker]="pickerField">
        <input
          matStartDate
          placeholder="After"
          [formControl]="start"
          (dateChange)="changeDate($event)"
        />
        <input
          matEndDate
          placeholder="Before"
          [formControl]="end"
          (dateChange)="changeDate($event)"
        />
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="pickerField" />
      <mat-date-range-picker #pickerField />
      @if (field.conditionalHint) {
        <mat-hint>{{ field.conditionalHint }}</mat-hint>
      }
    </mat-form-field>
  }
  @case ('presetRange') {
    <span class="rb-range-picker-container">
      <mat-form-field class="me-2">
        <mat-label>{{ field.label }}</mat-label>
        <mat-select
          [formControl]="presetRangeControl"
          (selectionChange)="rangeSelection($event)"
        >
          @for (opt of floatingRangeOptions; track opt.value) {
            <mat-option value="{{ opt.value }}">
              {{ opt.display }}
            </mat-option>
          }
        </mat-select>
        @if (presetRangeControl.value) {
          <button
            matSuffix
            matIconButton
            aria-label="Clear"
            color="warn"
            type="button"
            matTooltip="Clear Filter"
            (click)="clearRange($event)"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
        @if (field.conditionalHint) {
          <mat-hint>{{ field.conditionalHint }}</mat-hint>
        }
      </mat-form-field>
      <mat-form-field
        class="me-2 preset-date-picker"
        [ngClass]="{
          visible: presetRangeControl.value === 'custom',
        }"
      >
        <mat-label>{{ field.label }}</mat-label>
        <mat-date-range-input [rangePicker]="pickerField" [min]="minDate">
          <input
            #startDatePicker
            matStartDate
            placeholder="After"
            [formControl]="start"
            (dateChange)="changeDate($event)"
          />
          <input
            #endDatePicker
            matEndDate
            placeholder="Before"
            [formControl]="end"
            (dateChange)="changeDate($event)"
          />
        </mat-date-range-input>
        <button
          matSuffix
          matIconButton
          aria-label="Clear"
          color="warn"
          type="button"
          (click)="clearRange($event)"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-datepicker-toggle matIconSuffix [for]="pickerField" />
        <mat-date-range-picker #pickerField />
      </mat-form-field>
    </span>
  }
  @case ('valueRange') {
    <span>
      <mat-form-field>
        <mat-label>{{ field.label }}</mat-label>
        <input
          #currencyRangeTrigger
          matInput
          [matMenuTriggerFor]="valueRangeMenu"
          [value]="formattedRangeValue()"
          [matMenuTriggerRestoreFocus]="false"
          [readonly]="true"
        />
        @if (field.conditionalHint) {
          <mat-hint>{{ field.conditionalHint }}</mat-hint>
        }
      </mat-form-field>

      <mat-menu #valueRangeMenu="matMenu" direction="down" yPosition="below">
        <div class="additional-filter-label">
          {{ field.label }}
        </div>
        <button
          type="button"
          mat-menu-item
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
        >
          <mat-form-field class="w-100">
            <mat-label>Min.</mat-label>
            <input
              matInput
              maxlength="20"
              [formControl]="minField"
              (input)="changeValueRange($event, 'minField')"
            />
            @if (!minField.value && maxField.value) {
              <mat-hint> This field will default to 0 </mat-hint>
            }
          </mat-form-field>
          <mat-form-field class="w-100">
            <mat-label>Max.</mat-label>
            <input
              matInput
              maxlength="20"
              [formControl]="maxField"
              (input)="changeValueRange($event, 'maxField')"
            />
            @if (minField.value && !maxField.value) {
              <mat-hint> This field will default to 99999999 </mat-hint>
            }
          </mat-form-field>
        </button>
      </mat-menu>
    </span>
  }
  @case ('currencyRange') {
    <span>
      <mat-form-field>
        <mat-label>{{ field.label }}</mat-label>
        <input
          #currencyRangeTrigger
          matInput
          [matMenuTriggerFor]="valueRangeMenu"
          [value]="formattedRangeValue()"
          [matMenuTriggerRestoreFocus]="false"
          [readonly]="true"
        />
        @if (field.conditionalHint) {
          <mat-hint>{{ field.conditionalHint }}</mat-hint>
        }
      </mat-form-field>

      <mat-menu #valueRangeMenu="matMenu" direction="down" yPosition="below">
        <div class="additional-filter-label">
          {{ field.label }}
        </div>
        <button
          type="button"
          mat-menu-item
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
        >
          <mat-form-field class="w-100">
            <mat-label>Min.</mat-label>
            <input
              matInput
              maxlength="20"
              [maskito]="dollarMask"
              [formControl]="minField"
              (input)="changeValueRange($event, 'minField')"
            />
            @if (
              (!minField.value || minField.value === '$') &&
              maxField.value !== '$' &&
              maxField.value
            ) {
              <mat-hint> This field will default to $0 </mat-hint>
            }
          </mat-form-field>
          <mat-form-field class="w-100">
            <mat-label>Max.</mat-label>
            <input
              matInput
              maxlength="20"
              [maskito]="dollarMask"
              [formControl]="maxField"
              (input)="changeValueRange($event, 'maxField')"
            />
            @if (
              minField.value !== '$' &&
              minField.value &&
              (!maxField.value || maxField.value === '$')
            ) {
              <mat-hint> This field will default to $99999999 </mat-hint>
            }
          </mat-form-field>
        </button>
      </mat-menu>
    </span>
  }
  @case ('relatedDate') {
    <span>
      <mat-form-field class="me-2">
        <mat-label>{{ field.label }}</mat-label>
        <mat-date-range-input [rangePicker]="rangePickerOne">
          <input
            matStartDate
            placeholder="Start date"
            [formControl]="start"
            (dateChange)="changeDate($event)"
          />
          <input
            matEndDate
            placeholder="End date"
            [formControl]="end"
            (dateChange)="changeDate($event)"
          />
        </mat-date-range-input>
        <mat-hint> Cannot be used with '{{ field.relatedLabel }}' </mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="rangePickerOne" />
        <mat-date-range-picker #rangePickerOne />
        @if (field.conditionalHint) {
          <mat-hint>{{ field.conditionalHint }}</mat-hint>
        }
      </mat-form-field>

      <mat-form-field class="me-2">
        <mat-label>{{ field.relatedLabel }}</mat-label>
        <mat-date-range-input [rangePicker]="rangePickerTwo">
          <input
            matStartDate
            placeholder="Start date"
            [formControl]="relatedStart"
            (dateChange)="changeRelatedDate($event)"
          />
          <input
            matEndDate
            placeholder="End date"
            [formControl]="relatedEnd"
            (dateChange)="changeRelatedDate($event)"
          />
        </mat-date-range-input>
        <mat-hint> Cannot be used with '{{ field.label }}' </mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="rangePickerTwo" />
        <mat-date-range-picker #rangePickerTwo />
      </mat-form-field>
    </span>
  }
  @case ('bridgeidselect') {
    @if (showBridgeIdSelect) {
      <app-chip-filter
        [field]="field"
        [filterForm]="filterForm"
        [groupKey]="groupKey"
        (selectionChange)="selectionChange.emit($event)"
        (clearFilter)="clearFilter.emit($event)"
      />
    }
  }
}
